import { ZipIcon } from "../../../atoms/icons/zip";
import React from "react";

export const Zip = ({ zip }) => {
  return (
    <div className="irq-nav-wrapper">
      <ZipIcon className="margin-right" fill="white" />
      <span className="top-stats-text">Zip Code:</span>
      <div className="margin-left">
        <span className="large bold">{zip}</span>
      </div>
    </div>
  );
};
